import { useEffect, useState } from "react";

// Components
import Sidebar from "../../components/Sidebar";
import Main from "./TbSetServicePurpose/Main";
import Form from "./TbSetServicePurpose/Form";

// Utils
import { getAlert, getData } from "../../../utils/SamuiUtils";

const TbSetServicePurpose = () => {
  const [mode, setMode] = useState("");
  const [dataMasterList, setDataMasterList] = useState([]);
  const [selectedData, setSelectedData] = useState(null);
  const [formData, setFormData] = useState([]);

  useEffect(() => {
    initialize();
  }, []);

  const initialize = async () => {
    try {
      setMode("S");
      fetchRealtime();
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const fetchRealtime = async () => {
    try {
      const masterList = await getData(
        "Tb_Set_ServicePurpose",
        "1=1 ORDER BY ServicePurpose_Id"
      );
      if (masterList && masterList.length > 0) {
        setDataMasterList(masterList);
      } else {
        setDataMasterList([]);
      }
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const onPageInsert = () => {
    setMode("I");
  };

  const onRowSelected = (item) => {
    setMode("U");
    setFormData({
      ServicePurpose_Id: item.ServicePurpose_Id,
      ServicePurpose_Name: item.ServicePurpose_Name || "",
      ServicePurpose_Status: item.ServicePurpose_Status || "Y",
    });
    setSelectedData(item);
  };

  return (
    <div className="Creditor">
      <div className="wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="container">
            <div className="page-inner">
              {mode === "S" ? (
                <Main
                  masterList={dataMasterList}
                  name={"วัตถุประสงค์สถานที่บริการ"}
                  onPageInsert={() => onPageInsert()}
                  onRowSelected={(item) => onRowSelected(item)}
                />
              ) : (
                <Form
                  callInitialize={initialize}
                  mode={mode}
                  name={"วัตถุประสงค์สถานที่บริการ"}
                  formData={formData}
                  setFormData={setFormData}
                  selectedData={selectedData}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TbSetServicePurpose;
